import {getGameWindow} from './helper'

const isDevEnv = process.env.NODE_ENV === 'development' // FOR TESTING

export function muteGame() {
  // if (isDevEnv) return
  try {
    const gameWind = getGameWindow()
    gameWind?.gamezop?.mute()
  } catch (error) {
    console.log('Error while muting game: ', error)
  }
}

export function unmuteGame() {
  // if (isDevEnv) return
  try {
    const gameWind = getGameWindow()
    gameWind?.gamezop?.unmute()
  } catch (error) {
    console.log('Error while unmuting game: ', error)
  }
}

export function pauseAndMute() {
  // if (isDevEnv) return
  try {
    const gameWind = getGameWindow()
    gameWind?.gamezop?.pause()
    gameWind?.gamezop?.mute()
  } catch (error) {
    console.log('Error while pausing and muting game: ', error)
  }
}

export function playAndUnmute() {
  // if (isDevEnv) return
  try {
    const gameWind = getGameWindow()
    gameWind?.gamezop?.play()
    gameWind?.gamezop?.unmute()
  } catch (error) {
    console.log('Error while playing and unmuting game: ', error)
  }
}

export function focusGameIframe() {
  try {
    const gameWindow = getGameWindow()
    gameWindow.focus()
  } catch (error) {
    console.log('Error while focusing game iframe: ', error)
  }
}
